<template>
  <div class="app-wrapper">
    <navbar />
    <app-menu />
    <app-main/>
  </div>
</template>

<script>
import { AppMain, AppMenu, Navbar  } from './components'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UsLayout',
  components: {
    AppMain,
    Navbar,
    AppMenu,
  },
  computed: {
    ...mapGetters([
      'getVW',
    ]),
  },
  watch: {
    getVW(newV, oldV) {
      // console.log(newV, oldV);
    }
  },
  mounted() {
    this.getIndexInfo();
  },
  methods: {
    ...mapActions({
      actionIndexInfo: 'indexInfo',
    }),
    async getIndexInfo() {
      await this.actionIndexInfo();
    }
  }
}
</script>

<style lang="less" scoped>
  .app-wrapper {
    width: 100%;
    background: @themeColor6;
    font-family: pingfang;
  }
@media screen and (max-width: @xsW) {
  .app-wrapper {
    background: @themeColor5;
  }
}
</style>
